/**
 * Momentum Brief Lesson
 * Skill Area: Leadership
 * Build a roadmap for high-stakes talks
 */

import type { LessonDefinition } from '../types';
import {
  MOMENTUM_BRIEF_AI_PROMPT,
  MOMENTUM_BRIEF_CONTEXT_SCENARIOS,
} from '../prompts/momentum-brief.prompt';

export const momentumBrief: LessonDefinition = {
  id: 'momentum-brief',
  title: 'Momentum Brief',
  displayTitle: 'Build a Roadmap for High-Stakes Talks',
  subTitle: 'Create a prompt to practice difficult conversations.',
  tagline: 'Build a custom roleplay prompt for any situation.',
  persona: 'Lyra',
  skillArea: 'Leadership',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 6,
  tags: ['leadership', 'briefing', 'alignment'],
  dailyEligible: false,
  releasedAt: '2025-02-25T00:00:00.000Z',
  route: '/micro/momentum-brief',
  storyBeat: 'Lyra helps you build the perfect prompt to practice with.',
  contextTitle: 'Conversation starter',
  contextSummary:
    'Choose the type of tough talk you need to prep for. Lyra will help you build a prompt to simulate it safely.',
  contextScenarios: MOMENTUM_BRIEF_CONTEXT_SCENARIOS,
  introPrompt:
    "Practicing high-stakes conversations is smart, but generic AI roleplays depend on good prompting. I'll help you build a custom 'Simulator Prompt' you can use anywhere.",
  steps: [
    'Identify the tough conversation',
    'See a "Generic vs. Custom Roleplay" comparison',
    'Build your Simulator Prompt',
  ],
  promptGuidance: 'Choose a scenario below or type your own.',
  aiPrompt: MOMENTUM_BRIEF_AI_PROMPT,
  inputPlaceholder: "Type 'Asking for a Raise' or your own topic...",
  quickPrompts: ['Asking for a Raise', 'Firing a Volunteer', 'Board Disagreement'],
};
